(function () {
  'use strict';

  /* @ngdoc object
   * @name people.list
   * @description
   *
   */
  angular
    .module('people.list', [
      'ui.router'
    ]);
}());
